package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.hardware.component.eft

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.PaymentTerminalEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.kotlin_api.CashRegisterConfig
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.kotlin_api.EFTConfig
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.kotlin_api.HSPayStore
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.Constants.ipAddressRegex
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.jetbrains.compose.web.css.LineStyle


@Composable
fun EFT(
    cashRegisterConfig: CashRegisterConfig?,
    updateCashRegisterConfig: (List<Pair<String, dynamic>>) -> Unit
)
{
    val type = remember { mutableStateOf(cashRegisterConfig?.eftConfig?.type ?: 0) }
    val printEftReceipt = remember { mutableStateOf(cashRegisterConfig?.eftConfig?.printEftReceipt ?: false) }

    LaunchedEffect(cashRegisterConfig?.eftConfig){
        type.value = cashRegisterConfig?.eftConfig?.type ?: 0
        printEftReceipt.value = cashRegisterConfig?.eftConfig?.printEftReceipt ?: false
    }


//  MediumContentTitle(
//      title = Strings.current().eftTerminal
//  )

    Row(
        modifier = Modifier
            .margin(topBottom = Dimen.smallPadding)
            .fillMaxWidth()
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
            .borderRadius(Dimen.lowBorderRadius)
            .padding(Dimen.normalPadding),
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            CheckboxComponent(
                modifier = Modifier
                    .margin(bottom = Dimen.largePadding),
                checkStatus = printEftReceipt.value,
                title = Strings.current().printEFTReceipt,
                onChecked = {
                    printEftReceipt.value = true

                    updateCashRegisterConfig(
                        buildList { add(ApiUtils.Field.eftPrintReceipt to true) }
                    )
                },
                onUnChecked = {
                    printEftReceipt.value = false

                    updateCashRegisterConfig(
                        buildList { add(ApiUtils.Field.eftPrintReceipt to false) }
                    )
                }
            )

            DropDownItem(
                modifier = Modifier
                    .margin(bottom = Dimen.highLargePadding),
                label = Strings.current().terminal,
                options = PaymentTerminalEnum.entries,
                selectedItem = PaymentTerminalEnum.entries.find {
                    it.id == type.value
                },
                displayText = { item ->
                    if (item is PaymentTerminalEnum) item.title else ""
                },
                onOptionClick = {
                    if (it is PaymentTerminalEnum) {
                        type.value = it.id

                        updateCashRegisterConfig(
                            buildList { add(ApiUtils.Field.eftTerminalType to type.value) }
                        )
                    }
                },
            )

            when (type.value) {
                PaymentTerminalEnum.HS_PAY_TAP_TO_PAY.id -> {
                    HsPayTapToPay(
                        storeId = cashRegisterConfig?.eftConfig?.hsPayStoreId.orEmpty(),
                        stores = cashRegisterConfig?.hsPayStores.orEmpty(),
                        updateCashRegisterConfig = { updateList: List<Pair<String, dynamic>> ->
                            updateCashRegisterConfig(updateList)
                        }
                    )
                }

                PaymentTerminalEnum.HS_PAY_CLOUD.id -> {
                    HsPayCloud(
                        eftConfig = cashRegisterConfig?.eftConfig,
                        updateCashRegisterConfig = { updateList: List<Pair<String, dynamic>> ->
                            updateCashRegisterConfig(updateList)
                        }
                    )
                }

                PaymentTerminalEnum.WALLEE_CLOUD_API.id->{
                    WalleeCloudAPI (
                        eftConfig = cashRegisterConfig?.eftConfig,
                        updateCashRegisterConfig = { updateList: List<Pair<String, dynamic>> ->
                            updateCashRegisterConfig(updateList)
                        }
                    )
                }

                PaymentTerminalEnum.NEXI_ATTENDED.id -> {
                    NexiAttended(
                        eftConfig = cashRegisterConfig?.eftConfig,
                        updateCashRegisterConfig = { updateList: List<Pair<String, dynamic>> ->
                            updateCashRegisterConfig(updateList)
                        }
                    )
                }


                PaymentTerminalEnum.WORLDLINE_TIM.id->{
                    WordLineTim(
                        eftConfig = cashRegisterConfig?.eftConfig,
                        updateCashRegisterConfig = { updateList: List<Pair<String, dynamic>> ->
                            updateCashRegisterConfig(updateList)
                        }
                    )
                }
            }
        }
    }
}

@Composable
private fun HsPayTapToPay(
    storeId: String,
    stores: List<HSPayStore>,
    updateCashRegisterConfig: (List<Pair<String, dynamic>>) -> Unit
) {
    val workStoreId = remember { mutableStateOf(storeId) }

    LaunchedEffect(storeId) {
        workStoreId.value = storeId
    }

    DropDownItem(
        modifier = Modifier
            .margin(bottom = Dimen.mediumPadding),
        label = Strings.current().store ,
        options = stores,
        selectedItem = stores.find { it.id == workStoreId.value },

        displayText = { item ->
            if (item is HSPayStore) item.name else ""
        },
        onOptionClick = {
            if (it is HSPayStore) {
                workStoreId.value = it.id

                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.eftHSPayTapToPayStoreId to workStoreId.value) }
                )
            }
        }
    )
}

@Composable
private fun HsPayCloud(
    eftConfig: EFTConfig?,
    updateCashRegisterConfig: (List<Pair<String, dynamic>>) -> Unit
) {
    val hsPayPoiId = remember { mutableStateOf(eftConfig?.hsPayPoiId.orEmpty()) }
    val hsPayUrl = remember { mutableStateOf(eftConfig?.hsPayUrl.orEmpty()) }
    val hsPayApiKey = remember { mutableStateOf(eftConfig?.hsPayApiKey.orEmpty()) }

    LaunchedEffect(eftConfig) {
        hsPayPoiId.value = eftConfig?.hsPayPoiId.orEmpty()
        hsPayUrl.value = eftConfig?.hsPayUrl.orEmpty()
        hsPayApiKey.value = eftConfig?.hsPayApiKey.orEmpty()
    }

    CustomEditText(
        modifier = Modifier,
        label = Strings.current().poiId,
        width = Dimen.mediumEditTextWidth,
        value = hsPayPoiId.value,
        isRequired = true,
        hint = "",
        onFocusIn = { },
        onFocusOut = {
            updateCashRegisterConfig(
                buildList { add(ApiUtils.Field.eftHSPayPoiId to hsPayPoiId.value) }
            )
        },
        onInputChange = { it, validation ->
            hsPayPoiId.value = it
            validation.value = hsPayPoiId.value.isNotBlank()
        }
    )

    CustomEditText(
        modifier = Modifier,
        label = Strings.current().liveEndpointUrlPrefix,
        width = Dimen.mediumEditTextWidth,
        value = hsPayUrl.value,
        isRequired = true,
        hint = "",
        onFocusIn = { },
        onFocusOut = {
            updateCashRegisterConfig(
                buildList { add(ApiUtils.Field.eftHSPayLiveUrl to hsPayUrl.value) }
            )
        },
        onInputChange = { it, validation ->
            hsPayUrl.value = it
            validation.value = hsPayUrl.value.isNotBlank()
        }
    )

    CustomEditText(
        modifier = Modifier,
        label = Strings.current().apiKey,
        width = Dimen.mediumEditTextWidth,
        value = hsPayApiKey.value,
        isRequired = true,
        hint = "",
        onFocusIn = { },
        onFocusOut = {
            updateCashRegisterConfig(
                buildList { add(ApiUtils.Field.eftHSPayApiKey to hsPayApiKey.value) }
            )
        },
        onInputChange = { it, validation ->
            hsPayApiKey.value = it
            validation.value = hsPayApiKey.value.isNotBlank()
        }
    )
}

@Composable
private fun WalleeCloudAPI(
    eftConfig: EFTConfig?,
    updateCashRegisterConfig: (List<Pair<String, dynamic>>) -> Unit
) {
    val walleeKey = remember { mutableStateOf(eftConfig?.walleeKey.orEmpty()) }
    val walleeVirtualTid = remember { mutableStateOf(eftConfig?.walleeVirtualTid.orEmpty()) }
    val walleeUser = remember { mutableStateOf(eftConfig?.walleeUser.orEmpty()) }
    val walleeSpace = remember { mutableStateOf(eftConfig?.walleeSpace.orEmpty()) }
    val walleeTid = remember { mutableStateOf(eftConfig?.walleeTid.orEmpty()) }

    LaunchedEffect(eftConfig) {
        walleeKey.value = eftConfig?.walleeKey.orEmpty()
        walleeVirtualTid.value = eftConfig?.walleeVirtualTid.orEmpty()
        walleeUser.value = eftConfig?.walleeUser.orEmpty()
        walleeSpace.value = eftConfig?.walleeSpace.orEmpty()
        walleeTid.value = eftConfig?.walleeTid.orEmpty()
    }

    Row {
        CustomEditText(
            modifier = Modifier,
            label = Strings.current().applicationKey,
            width = Dimen.mediumEditTextWidth,
            value = walleeKey.value,
            isRequired = true,
            hint = "",
            onFocusIn = { },
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.eftWalleeKey to walleeKey.value) }
                )
            },
            onInputChange = { it, validation ->
                walleeKey.value = it
                validation.value = walleeKey.value.isNotBlank()
            }
        )

        CustomEditText(
            modifier = Modifier
                .margin(left = Dimen.mediumPadding),
            label = Strings.current().roomId,
            width = Dimen.mediumEditTextWidth,
            value = walleeSpace.value,
            isRequired = true,
            hint = "",
            onFocusIn = { },
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.eftWalleeSpace to walleeSpace.value) }
                )
            },
            onInputChange = { it, validation ->
                walleeSpace.value = it
                validation.value = walleeSpace.value.isNotBlank()
            }
        )
    }

    Row {
        CustomEditText(
            modifier = Modifier,
            label = Strings.current().virtualTerminalId,
            width = Dimen.mediumEditTextWidth,
            value = walleeVirtualTid.value,
            isRequired = true,
            hint = "",
            onFocusIn = { },
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.eftWalleeVirtualTid to walleeVirtualTid.value) }
                )
            },
            onInputChange = { it, validation ->
                walleeVirtualTid.value = it
                validation.value = walleeVirtualTid.value.isNotBlank()
            }
        )

        CustomEditText(
            modifier = Modifier
                .margin(left = Dimen.mediumPadding),
            label = Strings.current().terminalId,
            width = Dimen.mediumEditTextWidth,
            value = walleeTid.value,
            isRequired = true,
            hint = "",
            onFocusIn = { },
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.eftWalleeTid to walleeTid.value) }
                )
            },
            onInputChange = { it, validation ->
                walleeTid.value = it
                validation.value = walleeTid.value.isNotBlank()
            }
        )
    }

    Row {
        CustomEditText(
            modifier = Modifier,
            label = Strings.current().userId,
            width = Dimen.mediumEditTextWidth,
            value = walleeUser.value,
            isRequired = true,
            hint = "",
            onFocusIn = { },
            onFocusOut = {
                updateCashRegisterConfig(
                    buildList { add(ApiUtils.Field.eftWalleeUser to walleeUser.value) }
                )
            },
            onInputChange = { it, validation ->
                walleeUser.value = it
                validation.value = walleeUser.value.isNotBlank()
            }
        )
    }
}


@Composable
private fun NexiAttended(
    eftConfig: EFTConfig?,
    updateCashRegisterConfig: (List<Pair<String, dynamic>>) -> Unit
) {
    val ip = remember { mutableStateOf(eftConfig?.ip.orEmpty()) }
    val port = remember { mutableStateOf(eftConfig?.port ?: 0) }

    LaunchedEffect(eftConfig) {
        ip.value = eftConfig?.ip.orEmpty()
        port.value = eftConfig?.port ?: 0
    }

    CustomEditText(
        modifier = Modifier,
        label = Strings.current().tcpIP,
        width = Dimen.mediumEditTextWidth,
        value = ip.value,
        isRequired = true,
        hint = "",
        onFocusIn = { },
        onFocusOut = {
            updateCashRegisterConfig(
                buildList { add(ApiUtils.Field.eftTerminalIp to ip.value) }
            )
        },
        onInputChange = { it, validation ->
            ip.value = it
            validation.value = Regex(ipAddressRegex).matches(ip.value)
        },
    )

    CustomEditText(
        modifier = Modifier,
        label = Strings.current().port,
        width = Dimen.mediumEditTextWidth,
        value = "${port.value}",
        isRequired = true,
        hint = "",
        onFocusIn = { },
        onFocusOut = {
            updateCashRegisterConfig(
                buildList { add(ApiUtils.Field.eftTerminalPort to port.value) }
            )
        },
        onInputChange = { it, validation ->
            port.value = it.toIntOrNull() ?: 0
            validation.value = port.value in 1..65535
        }
    )
}

@Composable
private fun WordLineTim(
    eftConfig: EFTConfig?,
    updateCashRegisterConfig: (List<Pair<String, dynamic>>) -> Unit
) {
    val tid = remember { mutableStateOf(eftConfig?.tid.orEmpty()) }

    LaunchedEffect(eftConfig) {
        tid.value = eftConfig?.tid.orEmpty()
    }

    CustomEditText(
        modifier = Modifier,
        label = Strings.current().tId,
        width = Dimen.mediumEditTextWidth,
        value = tid.value,
        isRequired = true,
        hint = "",
        onFocusIn = { },
        onFocusOut = {
            updateCashRegisterConfig(
                buildList { add(ApiUtils.Field.eftTerminalTid to tid.value) }
            )
        },
        onInputChange = { it, validation ->
            tid.value = it
            validation.value = tid.value.isNotBlank()
        }
    )
}
